// Generated types for Connection
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ConnectionReadAPI extends RFLPElementReadAPI {
  /** Reviewer / annotation notes on the connection. */
  notes?: string | null;
  /** True when this Connection needs no dedicated realizing parts — the physical link is integral to the connected parts (board-mounted connector, welded joint). */
  integral_realization?: boolean;
}

export interface ConnectionWriteAPI extends RFLPElementWriteAPI {
  /** Reviewer / annotation notes on the connection. */
  notes?: string | null;
  /** True when this Connection needs no dedicated realizing parts — the physical link is integral to the connected parts (board-mounted connector, welded joint). */
  integral_realization?: boolean;
  /** Internal INTERFACE Requirements this Connection is responsible for (the realized pairing). Conformance is proven separately via verification, not asserted by this edge. */
  satisfies?: string[];
  /** One endpoint port of this Connection. */
  port_a?: string;
  /** The other endpoint port of this Connection. */
  port_b?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ConnectionReadAPISchema: z.ZodType<ConnectionReadAPI> = RFLPElementReadAPISchemaObject.extend({
  notes: z.string().nullable().optional(),
  integral_realization: z.boolean().optional(),
}).passthrough();

export const ConnectionWriteAPISchema: z.ZodType<ConnectionWriteAPI> = RFLPElementWriteAPISchemaObject.extend({
  notes: z.string().nullable().optional(),
  integral_realization: z.boolean().optional(),
  satisfies: z.array(z.string()).optional(),
  port_a: z.string().optional(),
  port_b: z.string().optional(),
}).passthrough();
